import { NgModule } from '@angular/core';
import { SpinnerBackgroundComponent } from './spinner-background.component';

@NgModule({
  imports: [SpinnerBackgroundComponent],
  exports: [SpinnerBackgroundComponent]
})
export class SpinnerBackgroundModule {}
